import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genHorizontalStyle = function genHorizontalStyle(token) {
  var componentCls = token.componentCls;
  var stepsItemCls = "".concat(componentCls, "-item"); // .ant-steps-item

  return _defineProperty({}, "".concat(componentCls, "-horizontal"), _defineProperty({}, "".concat(stepsItemCls, "-tail"), {
    transform: 'translateY(-50%)'
  }));
};

export default genHorizontalStyle;